import React from 'react';
import healthCompassLogo from '/icons/logos/health-compass.svg';

const CommonAuthComponent = ({ children, innerClassName, alignTop = false }) => {
  return (
    <div className={`min-h-screen flex ${alignTop ? 'items-start pt-2' : 'items-center'} justify-center relative`}>

      {/* 🔹 Background Image Layer */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat z-0"
        style={{
          backgroundImage: `url('/images/overview-image.png')`,
        }}
      ></div>

      {/* 🔹 Optional overlay on top of background image */}
      <div className="absolute inset-0 bg-white bg-opacity-0 z-10" />

      {/* 🔸 Auth White Box Container */}
      <div className="relative z-20 w-full px-4">
        <div
          className={`auth-white-box text-teal-300 mx-auto w-full max-w-[500px] 
          bg-white/60 rounded-[16px] shadow-[4px_4px_30px_0px_#017E9D80] px-[50px] py-8 text-sm ${innerClassName || ''}`}>
          <div className="flex justify-center mb-5">
            <img
              src={healthCompassLogo}
              alt="healthcompass Rx"
              className="h-[72px] max-w-[320px]"
            />
          </div>
          {/* ⬇️ This is where your login/forgot-password form goes */}
          {children}
        </div>
      </div>

      {/* 🔹 Language Selector */}
      <div className="absolute bottom-6 right-6 z-20">
        <div className="bg-white rounded-lg shadow-md px-4 py-2 flex items-center space-x-2 cursor-pointer hover:bg-gray-100 transition">
          <img
            src="/images/Flag_of_Canada.svg"
            alt="Canada Flag"
            className="w-6 h-4 object-cover rounded-sm"
          />
          <span className="text-sm text-gray-700">Ontario / EN (Canada)</span>
          {/* <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"> */}
            {/* <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /> */}
          {/* </svg> */}
        </div>
      </div>

    </div>
  );
};

export default CommonAuthComponent;
